import RichText from '@/features/shared/RichText';
import { Theme } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo } from 'react';
import { Segments } from './Segments';

const AnimatedHeading = ({
  staticText,
  list,
  index,
  staticSegmentClassName = '',
  animatedSegmentClassName = '',
  duration = 500,
  delay = 0,
  onAnimationEnd = () => {},
  animateFromTop = false,
  theme = Theme.light,
}: any) => {
  return (
    <>
      <RichText
        theme={theme}
        content={staticText}
        customStyles
        className={clsx(staticSegmentClassName)}
      />
      <Segments
        index={index}
        list={list}
        theme={theme}
        className={animatedSegmentClassName}
        onAnimationEnd={onAnimationEnd}
        duration={duration}
        delay={delay}
        animateFromTop={animateFromTop}
      />
    </>
  );
};

export default memo(AnimatedHeading);
